import { h, Fragment } from "preact";
import { useState, useEffect, useMemo, useCallback } from "preact/hooks";
import {
	Checkbox,
	FormControlLabel,
	Grid,

	Paper,
	Stack,
	Typography,
} from "@mui/material";

import { makeStyles } from "@mui/styles";

import PostAddIcon from "@mui/icons-material/PostAdd";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import MailIcon from "@mui/icons-material/Mail";
import RoomIcon from "@mui/icons-material/Room";
const useStyles = makeStyles((theme) => ({}));

export default function Bien1({ lastStep, nextStep, upperState, setUpperState }) {
	const [state, setState] = useState({ mails: [] });


	const handleChange = (event) => {
		setFormData({ ...formData, [event.target.name]: event.target.value });
	};

	useEffect(() => {
		fetch("/api/mails")
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						setState({ mails: res.pld });
						break;
					case "err":
						break;
					default:
						break;
				}
			});
	}, []);
	const handleChangeCheckbox = (event) => {
		setState({ ...state, [event.target.name]: event.target.checked });
	};

	return (
		<Grid container spacing={2} style="margin: 10px;">
			<Grid item xs={12}>
				<Paper style="padding: 10px;">
					<Stack flexDirection={"row"} justifyContent={"space-between"} alignItems={"center"}>
						<Typography variant="h5">Messages internes</Typography>
						<Stack flexDirection={"row"} justifyContent={"flex-end"} alignItems={"center"}>
						<FormControlLabel
							control={
								<Checkbox
									checked={state.follow_up}
									onChange={handleChangeCheckbox}
									name="read"
									color="primary"
								/>
							}
							label="Messages lus"
						/>
						<FormControlLabel
							control={
								<Checkbox
									checked={state.follow_up}
									onChange={handleChangeCheckbox}
									name="done"
									color="primary"
								/>
							}
							label="Dossiers clôturés"
						/>
					</Stack>
				</Stack>
			</Paper>

		</Grid>
			{
		state.mails.map((row) => (
			<>


				<Paper style="padding: 10px;">
					<Typography variant="h5" sstyle="margin-bottom: 20px;">
						{row.from}
					</Typography>
					<Typography variant="h5" sstyle="margin-bottom: 20px;">
						{row.sb}
					</Typography>
					<Typography variant="body1">{row.bd}</Typography>
				</Paper>

			</>
		))
	}
		</Grid >
	);
}
